import React, { useState } from 'react'
import { Row, Col, Button, Tooltip, Space, Dropdown, Menu } from 'antd'
import { DownOutlined } from '@ant-design/icons'
import FilePlus from '../../../assets/Images/FilePlus.svg'
import downloadImg from 'assets/Images/Download.svg'
import ImportBlog from './ImportBlog'
import ExportBlog from './ExportBlog'

export const PageHeaderBlog = ({ data, refetch, onNewBlogPost }: any) => {
  const [importVisible, setImportVisible] = useState(false)
  const [exportVisible, setExportVisible] = useState(false)

  const menu = (
    <Menu>
      <Menu.Item key="export" onClick={() => setExportVisible(true)}>
        <Space>
          <img alt="img" src={downloadImg} /> Export
        </Space>
      </Menu.Item>
      <Menu.Item key="import" onClick={() => setImportVisible(true)}>
        <Space>
          <img alt="importIcon" src={FilePlus} /> Import
        </Space>
      </Menu.Item>
    </Menu>
  )

  return (
    <>
      <Row className="page-header" justify="space-between">
        <Col lg={{ span: 6 }} xs={{ span: 24 }}>
          <h1 className="table-head mb-0">Blog</h1>
        </Col>
        <Col lg={{ span: 18 }} offset={6} xs={{ span: 24, offset: 0 }}>
          <div className="right-search-block">
            <div
              className="table-action-btn new-organizations-export-btn"
              style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}
            >
              <Dropdown overlay={menu} placement="bottom" className="bg-grey mx-20px">
                <button className="prim-sm-btn" style={{ color: 'black' }}>
                  More <DownOutlined />
                </button>
              </Dropdown>

              <Tooltip placement="bottom" title="Create">
                <Button className={'btn-new-activity primary br-8'} style={{ fontWeight: '500', fontSize: '15px' }} onClick={onNewBlogPost}>
                  Create <DownOutlined />
                </Button>
              </Tooltip>
            </div>
          </div>
        </Col>
      </Row>

      <ImportBlog visible={importVisible} onClose={() => setImportVisible(false)} onSuccess={refetch} />
      <ExportBlog visible={exportVisible} onClose={() => setExportVisible(false)} />
    </>
  )
}
export default PageHeaderBlog
